import React, { FC } from 'react';
import styled from 'styled-components';
import colors from '~/constants/colors';
import theme from '~/constants/theme';

const WizardContentContainer: any = (props: any) => {
  const { children } = props;
  return <Container>{children}</Container>;
};

const Container = styled.section`
  background-color: transparent !important;
  border-radius: 14px;
  display: flex;
  flex: 1;
  margin: 0 16px 16px 16px;
  padding: 16px;
  //max-width: ${theme.breakpoints.xl}px;
  @media (max-width: ${theme.breakpoints.xs}px) {
    margin: 0;
    padding: 32px;
    border-radius: ${theme.borderRadiusSm}px;
  }
`;

export default WizardContentContainer;
